import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/images/logo.png";
import {
  Badge,
  Container,
  styled,
  useTheme,
  Tabs,
  Tab,
  Menu,
  ListItemIcon,
  Collapse,
} from "@mui/material";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";
import SearchIcon from "@mui/icons-material/Search";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import Woman2OutlinedIcon from "@mui/icons-material/Woman2Outlined";
import Man2OutlinedIcon from "@mui/icons-material/Man2Outlined";
import WatchLaterOutlinedIcon from "@mui/icons-material/WatchLaterOutlined";
import { SlEyeglass } from "react-icons/sl";
import { GiBootPrints } from "react-icons/gi";
import DiamondOutlinedIcon from "@mui/icons-material/DiamondOutlined";
import { IoShirtOutline } from "react-icons/io5";
import ToysOutlinedIcon from "@mui/icons-material/ToysOutlined";
import ChairOutlinedIcon from "@mui/icons-material/ChairOutlined";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import USD from "../../assets/images/currency/usd.svg";
import EUR from "../../assets/images/currency/eur.svg";
import GBP from "../../assets/images/currency/gbp.svg";
import HKD from "../../assets/images/currency/hkd.svg";
import JPY from "../../assets/images/currency/jpy.svg";

import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import { cartSelector } from "../../redux/Cart/CartReducer";
import { wishlistSelector } from "../../redux/Wishlist/WishlistReducer";
const drawerWidth = "320px";
const navItems = [
  { title: "Home", link: "/home" },
  { title: "About", link: "/about" },
  { title: "Contact", link: "/contact" },
];
const drawerCategoriesArray = [
  { icon: <Woman2OutlinedIcon />, label: "Women's Clothing", link: "" },
  { icon: <Man2OutlinedIcon />, label: "Men's Clothing", link: "" },
  { icon: <WatchLaterOutlinedIcon />, label: "Watches", link: "" },
  { icon: <SlEyeglass />, label: "Acessories", link: "" },
  { icon: <GiBootPrints />, label: "Shoes", link: "" },
  { icon: <DiamondOutlinedIcon />, label: "Jewellery", link: "" },
  { icon: <IoShirtOutline />, label: "T-Shirt", link: "" },
  { icon: <ToysOutlinedIcon />, label: "Toys, Kids & ", link: "" },
  { icon: <ChairOutlinedIcon />, label: "Decor", link: "" },
];
const drawerMenuArray = [
  { label: "Demo", link: "" },
  { label: "Shop", link: "" },
  { label: "Product", link: "" },
  { label: "Sale", link: "" },
  { label: "Portfolio", link: "" },
  { label: "Lookbook", link: "" },
  { label: "Blog", link: "" },
  {
    icon: <FavoriteBorderOutlinedIcon />,
    label: "Wishlist",
    link: "/wishlist",
  },
  { icon: <SearchIcon />, label: "Search", link: "" },
  { icon: <PersonOutlineOutlinedIcon />, label: "Login / Register", link: "" },
];
const currencyList = [
  { icon: USD, label: "USD" },
  { icon: EUR, label: "EUR" },
  { icon: GBP, label: "GBP" },
  { icon: HKD, label: "HKD" },
  { icon: JPY, label: "JPY" },
];
//components
const StyledLogoText = styled((props) => (
  <Typography variant="h5" component="div" {...props}>
    {props.children}
  </Typography>
))(({ theme }) => ({
  display: "block",
  letterSpacing: "10px",
  fontFamily: "lato,sans-serif",
  fontSize: "20px",
  fontWeight: "800",
  [theme.breakpoints.down("lg")]: {
    margin: "auto",
    textAlign: "center",
    flexBasis: "200px",
  },
  [theme.breakpoints.down("sm")]: {
    margin: "auto",
    textAlign: "center",
    flexBasis: "200px",
  },
}));

const NavItemWrapper = styled((props) => (
  <Box {...props}>{props.children}</Box>
))(({ theme }) => ({
  margin: "auto",
  display: "block",
  [theme.breakpoints.down("lg")]: {
    display: "none",
  },
}));

const NavItemButton = styled((props) => (
  <Button variant="text" {...props}>
    {props.children}
  </Button>
))(({ theme }) => ({
  color: "#4D5959",
  flexBasis: 1,
  flexShrink: 0,
  flexGrow: 0,
  fontFamily: "lato, sans-serif",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "14px",
  letterSpacing: "3px",
  ":hover": {
    color: theme.palette.primary.main,
    background: "transparent",
  },
  [theme.breakpoints.down("md")]: {
    fontSize: "12px",
    letterSpacing: "1px",
  },
}));
const NavIconsWrapper = styled((props) => (
  <Box {...props}>{props.children}</Box>
))(({ theme }) => ({
  display: "block",
  "& .MuiSvgIcon-root": {
    fontSize: "1.7rem",
    stroke: "white",
  },
  [theme.breakpoints.down("lg")]: {
    flexBasis: "200px",
    textAlign: "right",
    "& .MuiSvgIcon-root": {
      // fontSize:'25px'
      fontSize: "1.7rem",
      stroke: "white",
    },
  },
  [theme.breakpoints.down("sm")]: {
    "& .personal_icon_btn": { display: "none" },
    "& .favourite_icon_btn": { display: "none" },
  },
}));

const StyledDrawer = styled((props) => (
  <Drawer {...props}>{props.children}</Drawer>
))(({ theme }) => ({
  display: { xs: "block", sm: "none" },
  "& .MuiDrawer-paper": {
    boxSizing: "border-box",
    width: drawerWidth,
  },
  "& .MuiTabs-flexContainer": {
    "& .MuiButtonBase-root": {
      padding: theme.spacing(2.5),
      width: "50%",
      border: "1px solid #E9E9E9",
    },
    "& .Mui-selected": {
      backgroundColor: "#E9E9E9",
    },
  },

  "& .menu  ,& .category": {
    "& .MuiButtonBase-root": {
      "& .MuiListItemIcon-root": {
        minWidth: "30px",
        marginRight: "5px",
        "& svg": {
          margin: "auto",
        },
      },
    },
  },
  "& .menu": {
    "& .MuiButtonBase-root": {
      "& .MuiListItemIcon-root": {
        "& svg": {
          margin: "0 !important",
          width: "100%",
        },
      },
    },
  },

  "& .help": {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    color: "#999999",
    "& .MuiTypography-root": {
      display: "block",
    },
    "& .email-help:hover": {
      color: theme.palette.primary.main,
      cursor: "pointer",
    },
    "& .phone-help:hover": {
      color: theme.palette.primary.main,
      cursor: "pointer",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "20px",
      verticalAlign: "middle",
      marginRight: "5px",
    },
  },

  "& .current_currency": {
    "& img": {
      width: "25px !important",
      marginRight: 0,
    },
  },
  "& .currencyList": {
    "& .MuiButtonBase-root": {
      paddingLeft: theme.spacing(4),
      "& img": {
        width: "25px",
      },
    },
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ padding: "2px" }}>{children}</Box>}
    </div>
  );
}
//main Function
function Navbar(props) {
  const navigate = useNavigate();
  const cart = useSelector(cartSelector);
  const wishlist = useSelector(wishlistSelector);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [scrollY, setscrollY] = React.useState(0);
  const [drawerTab, setDrawerTab] = React.useState(0);
  const [currency, setCurrency] = React.useState({ icon: USD, label: "USD" });
  const [currencyOpen, setCurrencyOpen] = React.useState(false);
  const handleChangedrawerTab = (event, newValue) => {
    setDrawerTab(newValue);
  };
  React.useEffect(() => {
    const handleScroll = () => {
      setscrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Typography variant="h6" sx={{ my: 2 }}>
        Market
      </Typography>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item.title} disablePadding>
            <ListItemButton
              sx={{ textAlign: "center" }}
              onClick={() => navigate(item.link)}
            >
              <ListItemText primary={item.title} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const container =
    props.window !== undefined ? () => window().document.body : undefined;

  return (
    <>
      <AppBar
        component={"nav"}
        sx={{
          width: "100%",
          background: "white",
          boxShadow: "none",
          position: "sticky",
          zIndex: 40,

          top: {
            xs:
              scrollY < 64
                ? "-64px"
                : scrollY >= 64 && scrollY <= 200
                ? "-64px"
                : -1,
            sm:
              scrollY < 64
                ? "-64px"
                : scrollY >= 64 && scrollY <= 300
                ? "-64px"
                : -1,
            md:
              scrollY < 64
                ? "-64px"
                : scrollY >= 64 && scrollY <= 500
                ? "-64px"
                : -1,
          },

          height: "auto",
          overflow: "hidden",
          transition: "all 0.6s !important",
        }}
      >
        <Container maxWidth="xl">
          <Toolbar
            sx={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0 !important",
            }}
          >
            <Box sx={{ flexBasis: "200px", display: { lg: "none" } }}>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ mr: 2 }}
              >
                <MenuIcon sx={{ color: "grey" }} />
              </IconButton>
            </Box>

            <StyledLogoText sx={{ width: "180px", height: "60px" }}>
              <img
                width={"80px"}
                height={"60px"}
                style={{ objectFit: "contain" }}
                src={Logo}
                alt="fashion logo"
              />
            </StyledLogoText>
            <NavItemWrapper>
              {navItems.map((item) => (
                <NavItemButton
                  sx={{ fontWeight: "bold" }}
                  key={item.title}
                  onClick={() => {
                    navigate(item.link);
                  }}
                >
                  {item.title}
                </NavItemButton>
              ))}
            </NavItemWrapper>
            <NavIconsWrapper>
              <IconButton className="search_icon_btn" aria-label="">
                <SearchIcon />
              </IconButton>
              <IconButton className="personal_icon_btn" aria-label="">
                <PersonOutlineOutlinedIcon />
              </IconButton>
              <IconButton className="favourite_icon_btn" aria-label="">
                <Badge
                  badgeContent={String(wishlist.length)}
                  sx={{
                    "& .MuiBadge-badge": { background: "red", color: "white" },
                  }}
                >
                  <FavoriteBorderOutlinedIcon
                    onClick={() => navigate("/wishlist")}
                  />
                </Badge>
              </IconButton>
              <IconButton
                className="cart_icon_btn"
                aria-label=""
                onClick={() => navigate("/cart")}
              >
                <Badge
                  badgeContent={String(cart.totalQuantity)}
                  sx={{
                    "& .MuiBadge-badge": { background: "red", color: "white" },
                  }}
                >
                  <LocalMallOutlinedIcon />
                </Badge>
              </IconButton>
            </NavIconsWrapper>
          </Toolbar>
        </Container>
      </AppBar>
      <Box component="nav">
        <StyledDrawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          <Box>
            <Tabs
              value={drawerTab}
              onChange={handleChangedrawerTab}
              aria-label=""
            >
              <Tab label="MENU" />
              <Tab label="CATEGORIES" />
            </Tabs>
          </Box>
          <Box>
            <TabPanel className="menu" value={drawerTab} index={0}>
              <List>
                {drawerMenuArray.map((item) => (
                  <ListItemButton
                    divider
                    key={item.label}
                    onClick={() => navigate(item.link)}
                  >
                    {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}
                    <ListItemText primary={item.label} />
                  </ListItemButton>
                ))}
                <ListItem divider>
                  <Box className="help">
                    <Typography variant="body1">Need help?</Typography>
                    <Typography className="phone-help" variant="caption">
                      <PhoneOutlinedIcon />
                      +01 23456789
                    </Typography>
                    <Typography className="email-help" variant="caption">
                      <EmailOutlinedIcon />
                      Kalles@domain.com
                    </Typography>
                  </Box>
                </ListItem>
                <ListItemButton
                  className="current_currency"
                  divider
                  onClick={() => setCurrencyOpen((prev) => !prev)}
                >
                  <ListItemIcon>
                    <img src={currency.icon} alt={currency.label} />
                  </ListItemIcon>
                  <ListItemText primary={currency.label} />
                  {currencyOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={currencyOpen} timeout="auto" unmountOnExit>
                  <List className="currencyList">
                    {currencyList.map((item) => (
                      <ListItemButton
                        divider
                        key={item.label}
                        onClick={() =>
                          setCurrency({ icon: item.icon, label: item.label })
                        }
                      >
                        <ListItemIcon>
                          <img src={item.icon} alt={item.label} />
                        </ListItemIcon>
                        <ListItemText
                          primary={item.label}
                          sx={{
                            "& .MuiTypography-root": {
                              color: (theme) =>
                                item.label === currency.label &&
                                theme.palette.primary.main,
                            },
                          }}
                        />
                      </ListItemButton>
                    ))}
                  </List>
                </Collapse>
              </List>
              <></>
            </TabPanel>
            <TabPanel className="category" value={drawerTab} index={1}>
              <List>
                {drawerCategoriesArray.map((item) => (
                  <ListItemButton
                    divider
                    key={item.label}
                    onClick={() => navigate(item.link)}
                  >
                    {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}
                    <ListItemText primary={item.label} />
                  </ListItemButton>
                ))}
              </List>
            </TabPanel>
          </Box>
          {/* {drawer} */}
        </StyledDrawer>
      </Box>
    </>
  );
}

Navbar.propTypes = {
  window: PropTypes.func,
};

export default Navbar;
